import styled from "styled-components"
import Valuigi from "../assets/valuigi.jpg"
import { useContext } from "react"
import { LanguageContext } from "../context/LanguageContext"

const AboutMe = () => {
    const { lang } = useContext(LanguageContext)

    return <section id="About me" className="paleSections scrollable columnOnMobile" style={{position: "relative"}}>
    <div className="custom-shape-divider-top-1744989386">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
    </div>
    <StyledAboutMe>
        {lang === "en" ? <>
        <div className="hidden">
            <h2>About me</h2>
                <p>
                    Hello! I'm Valérie! <span className="smallText">(Nice to meet you!)</span>
                </p>
                <p>
                    Animator by day, and gamer by night. I love bringing ideas to life and putting my brain to work solving puzzles.
                </p>
                <p>
                    Over the past 10 years, I've had the opportunity to work on many wonderful productions, mainly as an animator and a rigger. I love learning new things, so I've also worked with other departments when help was needed. My time in the animation industry has no doubt shaped me into the harworking and dedicated person I am today! 
                </p>
                <p>
                    Enjoy browsing through some of my work below! 
                </p>
        </div>
        </> : <>
        <div className="hidden">
            <h2>À propos</h2>
                <p>
                    Coucou! Je m'appelle Valérie! <span className="smallText">(Enchantée!)</span>
                </p>
                <p>
                    Animatrice de jour, gamer de nuit. J'adore donner vie aux idées tout en faisant travailler mes méninges pour résoudre des problèmes. 
                </p>
                <p>
                    Au cours des 10 dernières années, j'ai eu l'opportunité de travailler sur plusieurs merveilleuses productions en tant qu'animatrice et rigger. J'aime aussi apprendre de nouvelles choses, alors j'ai également prêté main quand nécessaire à d'autres départements. Mon expérience dans l'industrie de l'animation a fait de moi la personne dédiée et assidue que je suis aujourd'hui!
                </p>
                <p>
                    J'espère que vous aurez plaisir à explorer un peu de mon travail ci-dessous!
                </p>
        </div>
        </>
        }
    </StyledAboutMe>
    <img src={Valuigi} alt="A photo of me!" className="valPhoto hidden"/>
    </section>
}

const StyledAboutMe = styled.div`
    max-width: 50%;
    min-height: 70vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p{
        padding: 5px;
    }
    @media screen and (max-width: 1024px) {
        &{max-width: 90%;}
    }
    @media screen and (max-width: 768px) {
        &{max-width: 90%;
        min-height: 55vh;}
    }
    @media screen and (max-width: 480px) {
        &{max-width: 90%;
        min-height: 40vh;}
    }
`


export default AboutMe